import {gql} from "@apollo/client";

export const CORE_TAG_FIELDS = gql`
  fragment CoreTagFields on Tag {
    id
    key
    value
    isDeleted
  }
`;

export const CREATE_TAG = gql`
  ${CORE_TAG_FIELDS}
  mutation AddTag($tag: String!) {
    createOneTag(data: {key: "tag", value: $tag}) {
      ...CoreTagFields
    }
  }
`;

export const GET_TAGS = gql`
  ${CORE_TAG_FIELDS}
  query GetTags {
    tags(orderBy: {value: asc}) {
      ...CoreTagFields
    }
  }
`;

export const GET_TAGS_FOR_SCHEMA = gql`
  ${CORE_TAG_FIELDS}
  query GetTags {
    tags(orderBy: {value: asc}) {
      ...CoreTagFields
      inUseBy {
        model
        count
      }
    }
  }
`;

export const UPDATE_TAG = gql`
  ${CORE_TAG_FIELDS}
  mutation updateTag($id: Int!, $tag: String!) {
    updateOneTag(where: {id: $id}, data: {key: {set: "tag"}, value: {set: $tag}}) {
      ...CoreTagFields
    }
  }
`;

export const DELETE_TAG = gql`
  ${CORE_TAG_FIELDS}
  mutation DeleteTag($id: Int!) {
    deleteOneTag(where: {id: $id}) {
      ...CoreTagFields
    }
  }
`;
